export const mainColor = '#005078'
export const darkColor = '#002D41'
export const secondaryColor = '#1964A8'
export const lightColor = '#00C9FF'
export const lighterColor = '#D6F6FF'
export const screenColor = '#DEF8FF'
export const mainBlue = '#3f51b5'
export const mainRed = '#f32525'
export const mainGrey = '#e5e3e3'
export const managerBlue = '#161832'